import { taskEditorRouteAction, taskEditorRouteLoader } from '@/routes/tasks/TaskEditor.route'
import TaskEditor from '@/routes/tasks/TaskEditor'
import { RoleRouteObject } from '@/types'
import { Roles } from '@/auth/azure/Roles'
import { createDescriptor } from '@/components/BreadCrumbs/BreadCrumbs'

export const TaskCreatorRoute: RoleRouteObject = {
  path: 'new',
  element: <TaskEditor creating={true} />,
  loader: taskEditorRouteLoader,
  action: taskEditorRouteAction,
  allowedRoles: [Roles.Guest],
  handle: {
    crumb: () => createDescriptor,
  },
}
